import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  text-align: center;
  font-size: 0.8rem;
  color: ${lightGrey2Color};
`;
